import type { RouteRecordRaw } from 'vue-router'
import { prefixRoutes, route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'

const APPOINTMENT_PREFIX = 'cabinet:medical-appointment'
const p = (name: string) => APPOINTMENT_PREFIX + ':' + name

export const MEDICAL_APPOINTMENT_LIST_VIEW_NAME = p('list')

const List = () => import('./views/List.vue')

const BASE_MODEL_NAME = 'medical-appointment/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global

  return [
    prefixRoutes(
      ':chainId/',
      [
        route('list/', List, MEDICAL_APPOINTMENT_LIST_VIEW_NAME, {
          meta: {
            title: () => $t('Appointments'),
            isHideCabinetHead: true,
          },
        }),

        {
          path: '',
          redirect: { name: MEDICAL_APPOINTMENT_LIST_VIEW_NAME },
        },
      ],
      options
    ),
  ]
}

export { BASE_MODEL_NAME }
